<template>
<div>
    <b-form-select :value="value" 
            @input="emit"
            :options="templateOptions">
        <template #first>
            <b-form-select-option :value="null" disabled>-- Izvēlēties e-pasta šablonu --</b-form-select-option>
        </template>
    </b-form-select>
    <b-card
    header="Priekšskatījums"
    :title="value && value.subject"
    >
    <b-card-body size="xl" style="white-space: pre-line; height: 150px;" class="overflow-auto">
    {{ value && value.content }}
    </b-card-body>
</b-card>
</div>
</template>
<script>
    import {mapGetters, mapActions } from 'vuex';
    import * as templateStoreTypes from '@/vuex/modules/template/template.store-types'
export default {
    name: 'template-select',
    props: ['value'],
    created() {
        this.getTemplates()
    },
    computed: {
            ...mapGetters('template', {
                templates: templateStoreTypes.GET_TEMPLATES
            }),
            templateOptions() {
                return this.templates.map(tpl => ({value: tpl, text: tpl.name }))
            }
    },
    methods: {
        ...mapActions('template', {
            getTemplates: templateStoreTypes.ACTION_GET_TEMPLATES,
        }),
        emit(value) {
            this.$emit('input', value)
        }
    }
}
</script>
